<template>
  <el-dialog
    top="80px"
    width="50%"
    title="行程所需信息"
    :visible.sync="resverationModifyVisible"
    :show="show"
    @close="OnClose()"
  >
    <el-form ref="resverationModifyForm" label-width="80px">
      <div v-if="this.modifyChecked.length!==0" class="show-check-info">
        当前所选信息:
        <div
          style="display:inline;color:#ff5421"
          v-for="(item,index) in this.modifyChecked"
          :key="index"
        >{{item}}，</div>
      </div>
      <el-form-item label="模版名称:">
        <el-input
          style="width:30%"
          maxlength="8"
          show-word-limit
          size="mini"
          v-model="resverationModifyName"
        ></el-input>
      </el-form-item>

      <div class="check-box-class">租车类相关</div>
      <el-form-item label-width="2%">
        <el-checkbox-group v-model="reservationModify">
          <el-checkbox
            v-for="(item,index) of this.rentCarData"
            :key="index"
            :label="item"
          >{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <div class="check-box-class">接机类相关</div>
      <el-form-item label-width="2%">
        <el-checkbox-group v-model="reservationModify">
          <el-checkbox
            v-for="(item,index) of this.pickUpAirportData"
            :key="index"
            :label="item"
          >{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <div class="check-box-class">送机类相关</div>
      <el-form-item label-width="2%">
        <el-checkbox-group v-model="reservationModify">
          <el-checkbox
            v-for="(item,index) of this.dropOffAirportData"
            :key="index"
            :label="item"
          >{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <div class="check-box-class">行程类信息</div>
      <el-form-item label-width="2%">
        <el-checkbox-group v-model="reservationModify">
          <el-checkbox
            v-for="(item,index) of this.tripData"
            :key="index"
            :label="item"
          >{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <div class="check-box-class">同行信息</div>
      <el-form-item label-width="2%">
        <el-checkbox-group v-model="reservationModify">
          <el-checkbox
            v-for="(item,index) of this.accompanyData"
            :key="index"
            :label="item"
          >{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelModifyVisible">取 消</el-button>
      <el-button v-if="this.button_type == 1" type="primary" @click="resverationModifyConfirm">确 定</el-button>
      <el-button v-if="this.button_type == 2" type="primary" @click="resverationModifyChange">修 改</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 点击后 返回对象，对象记录在checkbox的 lable中
//  type 决定展示的输入框类型： date、time、text、num、textarea、boolean
const rentCarData = [
  { name: "用车开始日期", type: "date", title: "carStartDate" },
  { name: "用车开始时间", type: "time", title: "carStartTime" },
  { name: "取车地名称", type: "text", title: "placeTake" },
  { name: "还车地名称", type: "text", title: "placeBack" },
  { name: "取车地地址", type: "textarea", title: "addressTake" },
  { name: "还车地地址", type: "textarea", title: "addressBack" },
  { name: "送达地电话", type: "text", title: "addressBackTell" },
  { name: "行李数量", type: "num", title: "packageNum" },
];
const pickUpAirportData = [
  { name: "抵达航班号", type: "text", title: "arrivalFlightCode" },
  { name: "接机日期", type: "date", title: "arrivalFlightDate" },
  { name: "航班抵达时间", type: "time", title: "arrivalFlightTime" },
  { name: "送达地名称", type: "text", title: "dropOffPlace" },
  { name: "送达地址", type: "textarea", title: "dropOffAddress" },
  { name: "送达地电话", type: "text", title: "dropOffTell" },
  { name: "是否落地签", type: "boolean", title: "arrivalVisa" },
];
const dropOffAirportData = [
  { name: "航班号", type: "text", title: "departureFlightCode" },
  { name: "航班日期", type: "text", title: "departureFlightDate" },
  { name: "接人地点名称", type: "text", title: "departurePickUpPlace" },
  { name: "接人地址", type: "textarea", title: "departurePickUpAddress" },
  { name: "接人地电话", type: "text", title: "departurePickUpTell" },
];
const tripData = [
  { name: "集合地点", type: "text", title: "gatherAddress" },
  { name: "集合地点说明", type: "text", title: "gatherInfo" },
  { name: "房间号", type: "text", title: "roomNo" },
];
const accompanyData = [
  { name: "总人数", type: "num", title: "totalPeople" },
  { name: "成人数", type: "num", title: "adultsNumber" },
  { name: "老人数", type: "num", title: "oldmanNumber" },
  { name: "儿童数", type: "num", title: "childNumber" },
  { name: "婴儿数", type: "num", title: "babyNumber" },
  { name: "学生数", type: "num", title: "studentPeople" },
];

export default {
  name: "res-template-modify",
  data() {
    return {
      template_id: "",
      button_type: 1,
      modifyChecked: [],
      resverationModifyVisible: this.show,
      resverationModifyName: "",
      reservationModify: [],
      rentCarData: rentCarData,
      pickUpAirportData: pickUpAirportData,
      dropOffAirportData: dropOffAirportData,
      tripData: tripData,
      accompanyData: accompanyData,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(show) {
        this.resverationModifyVisible = show;
        // console.log(show);
      },
    },
  },
  methods: {
    OnClose() {
      this.$emit("update:show", false);
      this.$emit("close", false);
    },
    // 修改模版
    resverationModifyChange() {
      this.$emit("changeTemplate", false);

      let template_obj = {
        template_id: this.template_id,
        template_name: this.resverationModifyName,
        template: this.reservationModify,
      };
      this.$http
        .post("/change_reservation_stencil", template_obj)
        .then((res) => {
          // console.log(res);
          const { data, errno, errmsg } = res.data;
          if (this.resverationModifyName === "") {
            this.$notify.error({
              title: "错误",
              message: "未填写模版名称",
            });
            return;
          }
          if (errno == "0") {
            this.$notify({
              title: "成功",
              message: errmsg,
              type: "success",
            });
            this.resverationModifyVisible = false;
            this.reservationModify = [];
            this.resverationModifyName = "";
          } else if (errno == "4003") {
            this.$notify.error({
              title: "错误",
              message: errmsg,
            });
          }
        });
    },
    // 添加模版
    resverationModifyConfirm() {
      if (this.resverationModifyName === "") {
        this.$notify.error({
          title: "错误",
          message: "未填写模版名称",
        });
        return;
      }
      // console.log(this.reservationModify);

      if (this.reservationModify.length == 0) {
        this.$notify.error({
          title: "错误",
          message: "至少选择一个所需信息",
        });
        return;
      }
      let modifyInfo = {};
      modifyInfo.template_name = this.resverationModifyName;
      modifyInfo.template = this.reservationModify;

      this.$http.post("/add_reservation_stencil", modifyInfo).then((res) => {
        const { data, errno, errmsg } = res.data;
        this.$notify({
          title: "成功",
          message: errmsg,
          type: "success",
        });

        this.resverationModifyVisible = false;
        this.reservationModify = [];
        this.resverationModifyName = "";
      });
    },
    cancelModifyVisible() {
      this.$emit("cancelButton", false);
      this.resverationModifyVisible = false;
    },
  },
};
</script>

<style>
.show-check-info {
  background-color: whitesmoke;
  padding: 10px;
  margin-left: 5px;
  border: 1px;
  border-radius: 5px;
  margin-bottom: 10px;
}
.check-box-class {
  font-size: medium;
  padding: 5px;
  padding-left: 10px;
  margin-left: 5px;
  background-color: lightgrey;
}
.el-dialog__body {
  padding: 5px 20px;
}
</style>